import { FunctionComponent, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

export interface IDropDownOption {
  label: string;
  value: string;
}

interface IProps {
  defaultText: string;
  options: IDropDownOption[];
  selected: any;
  onSelect: (option: IDropDownOption) => void;
}

const DropDown: FunctionComponent<IProps> = ({
  defaultText,
  options,
  selected,
  onSelect,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isActive, setIsActive] = useState(false);
  const handleClick = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    const clickOutSide = (e) => {
      if (
        dropdownRef.current !== null &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsActive(!isActive);
      }
    };

    if (isActive) {
      window.addEventListener('click', clickOutSide);
    }

    return () => {
      window.removeEventListener('click', clickOutSide);
    };
  }, [isActive]);

  return (
    <MenuContainer>
      <MenuTrigger onClick={handleClick}>
        {selected === '' ? defaultText : selected}
        <img src="/images/branch/ic_arrow_down.svg" alt="arrow_down" />
      </MenuTrigger>
      {isActive && (
        <MenuContent ref={dropdownRef}>
          {options.map((option: IDropDownOption) => {
            return (
              <MenuItem
                key={option.label}
                onClick={() => {
                  setIsActive(!isActive);
                  onSelect(option);
                }}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </MenuContent>
      )}
    </MenuContainer>
  );
};

export default DropDown;

const MenuContainer = styled.div`
  width: 45%;
  display: flex;
  max-height: 400px;
  background-color: 'transparent';
`;

const MenuTrigger = styled.div`
  background: #fff;
  cursor: pointer;
  display: flex;
  width: 100%;
  height: 20px;
  box-shadow: 0px 0px 8px 0px #001e511f;
  border-radius: 8px;
  font-family: Pretendard;
  color: #9e9e9e;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
`;

const MenuContent = styled.div`
  top: 98%;
  position: absolute;
  width: 45%;
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  box-shadow: 0px 0px 8px 0px #001e511f;
  border-radius: 8px;
  background: #fff;
`;

const MenuItem = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  font-family: Pretendard;
  height: 20px;
  border-bottom: 1px solid rgba(245, 245, 245, 1);

  color: #777777;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.02em;
  text-align: left;
`;
